// Renders child completion as ordinary finished activity; cross-ledger child
// initialization cannot be paired safely in this stream.
import { z } from 'zod';

import { defineStandalone } from '@apps/web/features/phoebe_chat_v3/registry/types';
import { ResolvedReferenceText } from '@apps/web/features/phoebe_chat_v3/ui/primitives/reference_badge';

const childCompletedPayloadSchema = z
    .object({
        customer_narration_past: z
            .string()
            .min(1)
            .max(120)
            .refine((value) => value.trim().length > 0)
            .optional(),
    })
    .strip();

export const childCompletedDefinitions = {
    child_completed: defineStandalone('child_completed', {
        disposition: 'render',
        schema: childCompletedPayloadSchema,
        malformed: {
            kind: 'placeholder',
            customerCopy: 'Looked into the request',
        },
        evidence: null,
        group: {
            kind: 'activity',
            boundary: 'consecutive_same_kind',
            phase() {
                return 'completed';
            },
            presentSummary(payload) {
                return (
                    payload.customer_narration_past ?? 'Looked into the request'
                );
            },
            pastSummary(payload) {
                return (
                    payload.customer_narration_past ?? 'Looked into the request'
                );
            },
        },
        render(payload) {
            return (
                <span>
                    <ResolvedReferenceText
                        text={
                            payload.customer_narration_past ??
                            'Looked into the request'
                        }
                    />
                </span>
            );
        },
    }),
} as const;

export const childCompletedContractFixtures = {
    valid: { customer_narration_past: 'Reviewed the request' },
    malformed: { customer_narration_past: 7 },
} as const;
